import React, { useState, useEffect } from "react";
import "./EducationSingle.css";
import styles from "./SingleEducation.module.scss";
import edu from "../../../Assets/img/edu.svg";
import axios from "axios";
import swal from "sweetalert";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { AiOutlineFieldTime } from "react-icons/ai";
import { IoLocationOutline } from "react-icons/io5";
import { BsGlobe } from "react-icons/bs";
import { FaGraduationCap } from "react-icons/fa";
import { RiBook2Fill } from "react-icons/ri";
import { useParams, useNavigate } from "react-router-dom";

function EducationSingle() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [title_fa, setTitleFa] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [document, setDocument] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [apply_link, setApplyLink] = useState("");
  const [deadline, setDeadline] = useState("");
  const [grade, setGrade] = useState("");
  const [major, setMajor] = useState("");
  const [jobId, setJobId] = useState("");
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
  getUser();
  getJobData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [id]);

  const getUser = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response.data);
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  };

  const getJobData = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-study-opportunity/${id}`
      )
      .then((response) => {
        console.log(response);
        const data = response.data;

        setJobId(data._id);
        setTitle(data.title || "");
        setTitleFa(data.title_fa || "");
        setCity(data.city || "");
        setCountry(data.country || "");
        setDocument(data.document || "");
        setGrade(data.grade || "");
        setMajor(data.major || "");
        setResponsibility(data.responsibility || "");
        setApplyLink(data.apply_link || "");

        // محاسبه ددلاین
        if (data.deadline) {
          const oneDay = 1000 * 60 * 60 * 24;
          const today = new Date();
          const deadlineDate = new Date(data.deadline.toString());
          const differenceMs = Math.abs(today - deadlineDate);
          const days = Math.round(differenceMs / oneDay);
          setDeadline(days);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const paymentCheck = () => {
    setLoading(true);
    axios
      .post(`https://arianaapp.arianaapply.com/api/V1/check-payment-for-apply`, {
        user_id: user._id,
        description: "as1",
      })
      .then((res) => {
        console.log("pay", res);
        if (res.data.status === 401) {
          setLoading(false);
          navigate("/pay-education");
        } else {
          setLoading(false);
          setTimeout(() => {
            window.open(`${apply_link}`);
          }, 300);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const send = () => {
    setLoader(true);

    console.log("user_id", user, jobId);
    axios
      .post(
        "https://arianaapp.arianaapply.com/api/V1/check-resume-studyOpportunity",
        {
          user_id: user._id,
          studyOpportunity_id: jobId,
        }
      )
      .then((response) => {
        console.log(response);
        setLoader(false);
        if (response.data.status === 401) {
          swal({
            title: "!خطا",
            text: "شما تابحال رزومه ایجاد نکرده اید ",
            icon: "error",
            button: "!باشه",
          });
        } else {
          swal({
            title: "!انجام شد",
            text: "درخواست شما با موفقیت ارسال شد ",
            icon: "success",
            button: "!باشه",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  return (
    <>
      {title.length > 0 ? (
        <div className={styles.singleJob}>
          <Header title="فرصت های تحصیلی" />

          <div className={styles.singleJobBody}>
            <div className={styles.singleTopCard}>
              <div className={styles.cardTop}>
                <div className={styles.TopDate}>
                  <p>فرصت: {deadline} روز</p>
                  <AiOutlineFieldTime />
                </div>
                <div className={styles.TopImg}>
                  <img src={edu} alt="JobSearch" />
                </div>
              </div>

              {title_fa && <h4>{title_fa}</h4>}
              <h4>{title}</h4>

              <div className={styles.cardText}>
                <p>
                  <IoLocationOutline /> شهر: {city}
                </p>
                <p>
                  <RiBook2Fill /> رشته: {major}
                </p>
                <p>
                  <BsGlobe /> کشور: {country}
                </p>
                <p>
                  <FaGraduationCap /> مقطع: {grade}
                </p>
              </div>

              <div className={styles.cardBtns}>
                <button
                  className={styles.cardBtn2}
                  type="button"
                  onClick={send}
                  disabled={loader}
                >
                  رزومه ات رو بفرست
                </button>

                <button
                  className={styles.cardBtn1}
                  type="button"
                  onClick={paymentCheck}
                  disabled={loading}
                >
                  لینک اصلی رو ببین
                </button>
              </div>
            </div>

            <div className={styles.singleBottomCard}>
              <div className={styles.bottomCardTitle}>
                <h2>مدارک مورد نیاز</h2>
                <div></div>
              </div>
              <p>{document}</p>
            </div>

            <div className={styles.singleBottomCard}>
              <div className={styles.bottomCardTitle}>
                <h2>مسئولیت ها</h2>
                <div></div>
              </div>
              <p>{responsibility}</p>
            </div>
          </div>

          <Footer active="edu" />
        </div>
      ) : (
        <div className="spinner">
          <Loader
            type="TailSpin"
            color="rgb(236, 177, 28)"
            height={80}
            width={80}
          />
        </div>
      )}
    </>
  );
}

export default EducationSingle;